export default __webpack_public_path__ + "static/media/logo.10cd9e5a.png";